@for (group of filterGroups(); track group.key) {
  @if (group.options.length > 0) {
    <div class="filter-group">
      <label class="filter-group-label">{{ group.label }}</label>

      @for (option of group.options; track option.id) {
        <mat-checkbox
          [checked]="isSelected(group.key, option.id)"
          (change)="onCheckboxChange(group.key, option.id, $event.checked)"
          class="mat-checkbox-stretch-label mat-checkbox-align-checkbox-top"
        >
          <div class="filter-option-content">
            <span class="filter-option-label">{{ option.label }}</span>
            <pill
              size="small"
              [color]="isSelected(group.key, option.id) ? 'primary' : 'gray'"
              [value]="option.count"
            ></pill>
          </div>
        </mat-checkbox>
      }
    </div>
  }
}
